<template>
  <div style="padding: 5px;">
    <label style="font-weight: normal; text-transform: none;"> {{ title }} filtern </label>
    <div style="display: inline-flex;">
      <input type="search" class="col-md-5 number-filter form-control search-input-field" ref="input"
        v-model="numberFilter.gte" @keydown.enter="onEnter" :placeholder="'Von'"
        @input="onChange" @keyup.down="onArrowDown" @keyup.up="onArrowUp">
      <center style="font-weight: normal;" class="col-md-2">  -  </center>
      <input type="search" class="col-md-5 form-control search-input-field" ref="input"
        v-model="numberFilter.lte" @keydown.enter="onEnter" :placeholder="'Bis'"
        @input="onChange" @keyup.down="onArrowDown" @keyup.up="onArrowUp">
    </div>
    <b-btn class="btn btn-sm btn-block" @click="search"> Anwenden </b-btn>
    <b-btn class="btn btn-sm btn-block" @click="deleteFilter"> Filter zurücksetzen </b-btn>
  </div>
</template>

<script>
import filterMixins from './filter-mixins'

export default {
  name: 'number-filter',
  mixins: [filterMixins],
  data () {
    return {
      numberFilter: {}
    }
  },
  methods: {
    search () {
      if (['age', 'day_nr'].includes(this.field)) {
        if (this.numberFilter.gte) this.numberFilter.gte = Math.round(this.numberFilter.gte.replace(',', '.'))
        if (this.numberFilter.lte) this.numberFilter.lte = Math.round(this.numberFilter.lte.replace(',', '.'))
      }
      this.$set(this.query.freeTextFilters, this.field, this.numberFilter)
      this.query.offset = 0
      this.$set(this.query, 'nChanges', this.query.nChanges + 1)
    },
    setOptions () {
      var setFilter = this.query.freeTextFilters[this.field]
      this.numberFilter = setFilter || {}
    }
  },
  watch: {
    'query.freeTextFilters': {
      handler () {
        this.numberFilter = this.query.freeTextFilters[this.field] || {}
      }
    }
  }
}
</script>

<style>
.number-filter {
  margin-bottom: 3px;
}

</style>



// WEBPACK FOOTER //
// src/components/plugins/numberFilter.vue